module.exports = __webpack_public_path__ + "img/1513385747.3ca2f6e4.jpg";